import { render } from "./Game.vue?vue&type=template&id=0a2422a9&scoped=true"
import script from "./Game.vue?vue&type=script&lang=js"
export * from "./Game.vue?vue&type=script&lang=js"

import "./Game.vue?vue&type=style&index=0&id=0a2422a9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a2422a9"

export default script